<template>
    <div class="container_width">
        <v-snackbar 
            v-model="alertDialog"
            top
            centered 
            elevation="20"
            :timeout="alertDuration"
            :color="alertColor" 
            class="pa-6"
            style="margin-top:5em">
            <div class="text-center title font-weight-medium white--text" 
                v-html="alertMessage">
            </div>
        </v-snackbar>

        <v-dialog 
            v-model="secondaryUserDialog"
            transition="dialog-top-transition"
			persistent
            max-width="45%">
            <v-card>
                <v-card-title class="primary darken-2">
                    <div class="white--text">Add an Additional User</div>
                    <v-spacer></v-spacer>
					<v-btn 
						icon
						class="ml-3 white--text"
						@click="closeSecondary()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
                </v-card-title>
                <v-card-text class="pt-2">
                    <SecondaryUser 
                        :parentUserId="parentUserId"
                        :project="secondaryProject"
						:thisUser="thisUser"
						:resetCreateNewUser="resetCreateNewUser"
						@refreshUsers="refreshUsers" />
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <v-dialog 
            v-model="disclaimerDialog" 
            width="44%"
            max-height="50%"
            scrollable
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-2 white--text d-flex justify-space-between">
                    Disclaimer
                    <v-btn
                        icon
                        @click="disclaimerDialog = false">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="my-6">
                    <ul class="avenir_book disclaimer_text_size disclaimer_list general_grey--text">
                        <li>Succession Resource Group provides sample form agreements that are prepared by our external professional counsel and tailored for the industry. These agreements are constantly being peer reviewed by our client's attorneys and accountants across the country and where appropriate, incremental improvements are made to ensure you start with a comprehensive and well-thought-out agreement.</li>
                        <li>SRG will work in the capacity of a scrivener, providing and filling in the agreements based on your previously shared requests/preferences. Because SRG is not a law firm or CPA firm and is not your legal or tax counsel, these form agreements are intended for use by our clients with their professional counsel.</li>
                        <li>Please take your time to read through the attached form contracts and verify the accuracy of the information provided. If you require changes, please let us know as soon as possible so we may expedite any necessary revisions.</li>
                        <li>Since this contract cannot and does not address all the unique facts and circumstances of each specific situation, as well as particular state laws, we recommend that it be reviewed by your attorney and CPA prior to signing this agreement.</li>
                        <li>If the contract requires no further changes, sign and date the document in all specified areas, including any exhibits, if applicable. Please note that the date of signing can differ from the effective date.</li>
                        <li>You may sign this contract in two or more counterparts, which will each be considered an original and together constitute one and the same instrument. You may provide your signed counterpart to the other party via fax or email.</li>
                        <li>Upon completion of the contract, please feel welcome to send us a copy of the signed document so that we may maintain a backup of it in our client files should you need us to refer to it in the future, or in case you are unable to find your copy.</li>
                    </ul>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="uploadIndependentDocsDialog" 
            persistent
            width="55%"
            elevation="8">
                <v-card>
                    <UploadDocs
                        :item={}
                        :fieldData="{'name': 'independent', 'props': {'multiple': 'true'}}"
                        :moduleKey="$route.params.mid"
                        :projectId="$route.params.pid"
                        :userId="authUser.id"
                        @cancel="closeFileUpload"
                        @confirm="independentDocsUpload()"
                    />
                </v-card>
        </v-dialog>

        <v-dialog 
            v-model="videoDialog" 
            persistent
            width="55%"
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-2 white--text d-flex justify-space-between">
                    {{ videoTitle }}
                    <v-btn
                        icon
                        @click="closeVideo()">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-6 align-center mx-auto">                    
                    <div v-if="videoValid === null || videoValid === false">
                        <v-progress-circular   
                            v-if="videoValid === null"
                            indeterminate
                            color="primary"
                            class="mx-auto my-12 py-12 d-block"
                            size="100"
                            width="5">
                        </v-progress-circular>

                        <div v-if="videoValid === false" class="d-block my-12 py-12 text-center sansation_title">
                            We're sorry, this video is not available at this time.
                        </div>
                    </div>

                    <VideoPlayer v-if="videoValid"
                        :key="videoUrl"
                        :video_id="videoUrl"
                        :video_src="videoSrc"
                        :video_type="videoType" />
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="calendlyDialog" 
            content-class="calendly_dialog"
            persistent
            :width="calendly_url.includes('calendly') ? '25%' : '55%'"
            elevation="8">
            <v-card
                height="100%"
            >
                <v-card-title class="headline primary darken-2 white--text d-flex justify-space-between">
                    Schedule a Call
                    <v-btn
                        icon
                        @click="closeCalendly()">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                    <div 
                        id="calendly_wrapper"
                    />
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="surveyDialog" 
            width="44%"
            max-height="50%"
            scrollable
            elevation="8">
            <v-form v-model="valid" ref="form">
            <v-card>
                <v-card-title class="headline primary darken-2 white--text">How Did We Do?</v-card-title>
                <v-card-text class="primary--text text--darken-1 subtitle-1 my-6">
                    <div class="my-5 mx-0 d-block">
                        <div class="my-2 mx-0">1. How was the timeliness and delivery of SRG&apos;s product/services?</div>
                        <v-select
                            v-model="surveydata.timeliness"
                            :rules="[(v) => !!v || 'Timeliness and delivery is required']"
                            required
                            solo
                            class="ml-4"
                            color="primary darken-3"
                            label="Select one.."
                            :items="['Perfect', 'Pretty Good', 'Could have been better', 'Needs Improvement']"
                        >
                        </v-select>
                        <div v-if="surveydata.timeliness != ''" class="mb-2 ml-4">{{ surveydata.timeliness != '' && surveydata.timeliness == 'Perfect' ? text_timeliness_feedback.perfect : surveydata.timeliness != '' && surveydata.timeliness != 'Perfect' ? text_timeliness_feedback.improve : '' }}</div>
                        <v-textarea
                            v-if="surveydata.timeliness != ''"
                            v-model="surveydata.timeliness_feedback"
                            solo
                            rows="3"
                            row-height="10"
                            color="primary darken-3"
                            class="ml-4"
                        ></v-textarea>
                    </div>

                    <div class="my-5 mx-0 d-block">
                        <div class="my-2 mx-0">2. How was SRG&apos;s level of communication, accessibility, professionalism and interaction?</div>
                        <v-select
                            v-model="surveydata.professionalism"
                            :rules="[(v) => !!v || 'Communication & professionalism is required']"
                            required
                            solo
                            class="ml-4"
                            color="primary darken-3"
                            label="Select one.."
                            :items="['Perfect', 'Pretty Good', 'Could have been better', 'Needs Improvement']"
                        >
                        </v-select>
                        <div v-if="surveydata.professionalism != ''" class="mb-2 ml-4">{{ surveydata.professionalism != '' && surveydata.professionalism == 'Perfect' ? text_professionalism_feedback.perfect : surveydata.professionalism != '' && surveydata.professionalism != 'Perfect' ? text_professionalism_feedback.improve : '' }}</div>
                        <v-textarea
                            v-if="surveydata.professionalism != ''"
                            v-model="surveydata.professionalism_feedback"
                            solo
                            rows="3"
                            row-height="10"
                            color="primary darken-3"
                            class="ml-4"
                        ></v-textarea>
                    </div>

                    <div class="my-5 mx-0 d-block">
                        <div class="my-2 mx-0">3. Considering SRG&apos;s fees for your project, was it...</div>
                        <v-select
                            v-model="surveydata.fees"
                            :rules="[(v) => !!v || 'Value for fees is required']"
                            required
                            solo
                            class="ml-4 mb-9"
                            color="primary darken-3"
                            label="Select one.."
                            :items="['An exceptional value, worth more than you paid', 'A good value, worth what you paid', 'A poor value, worth less than you paid']"
                        >
                        </v-select>
                    </div>

                    <div class="my-5 mx-0 d-block">
                        <div class="my-2 mx-0">4. Would you recommend SRG to colleagues and friends?</div>
                        <v-select
                            v-model="surveydata.recommend"
                            :rules="[(v) => !!v || 'Would you recommend SRG is required']"
                            required
                            solo
                            class="ml-4 mb-9"
                            color="primary darken-3"
                            label="Select one.."
                            :items="['Yes', 'No', 'Maybe']"
                            @change="showGoogleReview(surveydata.recommend)"
                        >
                        </v-select>
                    </div>
                    
                    <div class="my-5 mx-0 d-block">
                        <div class="my-2 mx-0">5. How did you learn about SRG?</div>
                        <v-select
                            v-model="surveydata.learn"
                            :rules="[(v) => !!v || 'How did you learn about SRG is required']"
                            required
                            solo
                            class="ml-4 mb-9"
                            color="primary darken-3"
                            label="Select one.."
                            :items="[
                                'SRG Blog/Website',
                                'Google/Bing/Yahoo Search Engine',
                                'Broker-Dealer/Custodian Referral',
                                'Lender Referral',
                                'Past Client Referral',
                                'Conference(s)',
                                'Social Media'
                            ]"
                        >
                        </v-select>
                    </div>

                    <div class="mt-6 mx-0 d-block">
                        <div class="my-2 mx-0">6. Please share your thoughts, comments, or suggestions. We would love any testimonials you can provide or learn what we could have done to make your experience better. (optional)</div>
                        <v-textarea
                            v-model="surveydata.comments_feedback"
                            solo
                            rows="4"
                            row-height="10"
                            color="primary darken-3"
                            class="ml-4"
                        ></v-textarea>
                    </div>

                    <div class="mb-6 mx-0 d-block">
                        <v-checkbox
                            v-model="surveydata.permission"
                            color="primary darken-3"
                        >
                            <span slot="label" class="pt-4 primary--text text--darken-2">I give SRG permission to use my survey/testimonial on future SRG publications or website. (optional)</span>
                        </v-checkbox>
                    </div>

                    <div class="my-6 mx-0 d-block">
                        <v-checkbox
                            v-model="surveydata.reference"
                            color="primary darken-3"
                        >
                            <span slot="label" class="pt-4 primary--text text--darken-2">Would you be willing to act as a reference for us if someone wanted to learn first hand about your experiences? (optional)</span>
                        </v-checkbox>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3 px-4">
                    <v-spacer></v-spacer>
                    <v-btn 
                        @click="submitSurvey" 
                        :class="{ red: !valid }"
                        elevation="2"
                        class="mr-3 primary white--text font-weight-medium">
                        Submit Survey
                    </v-btn>
                    <v-btn 
                        @click="clearSurvey" 
                        color="primary"
                        class=""
                        outlined>
                        Clear
                    </v-btn>
                </v-card-actions>
            </v-card>
            </v-form>
        </v-dialog>

        <v-dialog 
            v-model="surveyThanks" 
            width="44%"
            elevation="8"
        >
            <v-card>
                <v-card-title class="headline primary darken-3 white--text">
                    A Debt of Gratitude!
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="surveyThanks = false">
                        <v-icon color="pewter">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <div class="mt-10 mb-5 mx-3 d-block text-center">
                        <div class="my-0 mx-8 text-center d-inline"
                            v-for="expert in survey_team_images"
                            :key="expert.name"
                        >
                            <img :src="require(`@/${expert.image}`)" style="width: 112px" :alt="`${expert.name}, ${expert.title}`" :id="expert.name">
                        </div>
                    </div>
                    <div class="ma-5 d-block text-center" style="font-size: 1.1rem">
                        We thank you, {{ survey_clientname }}, for taking the time to answer a few questions!<br>
                        It was a pleasure working with you!
                    </div>
                    <div class="ma-5 mb-10 d-block text-center" style="font-size: 1.1rem">
                        - The SRG Team -
                    </div>
                    <div v-if="show_google_review" class="review-modal d-block text-center avenir_book mt-12">
                        <!-- <h2 class="sansation_subtitle">Leave a Google Review</h2> -->
                        <!-- <div class="d-block mt-1 mb-2">We appreciate your feedback!</div> -->
                        <a :href="googleReviewLink" target="_blank">
                            <v-btn
                                large
                                color="primary"
                                class="white--text text--darken-3">
                                Leave a Google Review
                            </v-btn>
                        </a>
                        <div class="d-block mt-1 mb-4" style="font-size: 1rem">We appreciate your feedback!</div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="uploadRevisionsDialog"
            max-width="60%"
            persistent
            elevation="8">
            
            <v-card>
                <UploadDocs
                    item=""
                    :fieldData="{'name': 'revision', 'props': {'multiple': 'true'}}"
                    :moduleKey="$route.params.mid"
                    :projectId="$route.params.pid"
                    :userId="authUser.id"
                    @cancel="closeFileUpload"
                    @confirm="wrapupRevisionsUpload()"
                />
            </v-card>
        </v-dialog>
    
        <v-dialog
            v-model="openNoRevisions"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">

            <v-card>
                <v-card-title class="white--text primary darken-2">No Revisions</v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    By confirming that you do not have any revisions to upload, this project's status will be advanced{{ advance_to_complete ? ' and marked complete.' : ' to the next step.' }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="cancelNoRevisions">
						Cancel
					</v-btn>
                    <v-btn 
						color="primary"
                        class="ml-6"
						@click="confirmNoRevisions">
						Confirm
					</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="openNoCall"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">

            <v-card>
                <v-card-title class="white--text primary darken-2">No Call Necessary</v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    By confirming that you do not need to schedule a call, this project's status will be advanced{{ advance_to_complete ? ' and marked complete.' : ' to the next step.' }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="cancelNoCalls">
						Cancel
					</v-btn>
                    <v-btn 
						color="primary"
                        class="ml-6"
						@click="confirmNoCall">
						Confirm
					</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="openOptOutConfirmation"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">

            <v-card>
                <v-card-title class="white--text primary darken-2">Opting Out</v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    By confirming that you are opting out, this project's status will be advanced{{ advance_to_complete ? ' and marked complete.' : ' to the next step.' }}

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="cancelOptOut">
						Cancel
					</v-btn>
                    <v-btn 
						color="primary"
                        class="ml-6"
						@click="confirmOptOut">
						Confirm
					</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog
            v-model="openAdvanceProjectConfirmation"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">

            <v-card>
                <v-card-title class="white--text primary darken-2">Advance Project Status</v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    {{ advanceDetails.label }}<br/>
                    By confirming, this project's status will be advanced{{ advance_to_complete ? ' and marked complete.' : ' to the next step.' }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="cancelAdvance">
						Cancel
					</v-btn>
                    <v-btn 
						color="primary"
                        class="ml-6"
						@click="confirmAdvance">
						Confirm
					</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog
            v-model="openDocSigningConfirmation"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">

            <v-card>
                <v-card-title class="white--text primary darken-2">Doc Signing Selection</v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    Please confirm that you want to receive and sign your documentaion via <strong>{{ doc_signing_selection }}</strong>.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="cancelDocSigningSelection">
						Cancel
					</v-btn>
                    <v-btn 
						color="primary"
                        class="ml-6"
						@click="confirmDocSigningSelection">
						Confirm
					</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="noRevisionsComplete"
            max-width="45%"
            elevation="8"
            content-class="revisions_dialogs">
            <v-card>
                <v-card-title class="white--text primary darken-2">
                    Project Completion
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="noRevisionsComplete = false">
                        <v-icon color="pewter">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-10 text-subtitle-1">
                    <div v-html="no_revision_complete_review"></div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-container class="min_height questionnaire_btm_margin mx-0 px-0" style="max-width: 1280px">
            <v-row no-gutters class="mt-4" align="stretch">
                <v-col cols="9" class="ml-0 pr-4 subtitle-1 font-weight-regular">
                    <div v-if="!readyToLoad" class="text-center py-12" style="width: 100%">
                        <v-progress-circular indeterminate color="primary" class="my-12" size="80" width="4"></v-progress-circular>
                    </div>
                    
                    <div v-if="readyToLoad">
                        <v-card  
                            v-if="mod_info.module_key != 'buyer'"
                            elevation="2"
                            class="ma-0 mb-5 pa-0">

                            <v-tabs 
                                vertical
                                grow
                                slider-size=4
                                color="primary"
                                class="ma-0 pa-0 general_grey--text"
                                active-class="active_step"
                                v-model="mod_info.steps_completed">
                                
                                <v-tab v-for="(stage, ndx) in mod_info.module_stages.filter(stage => !stage.is_independent)" :key="stage.id"
                                    class="justify-start align-center pl-3 py-3"
                                    style="border-right: 2px solid #EFEFEF; width:300px"
                                    :style="mod_info.last_stage == (ndx+1) ? '' : 'border-bottom:1px solid #EFEFEF'">
                                    
                                    <v-icon v-if="stage.show_completed" 
                                        color="secondary" 
                                        class="ml-1 mr-3" 
                                        size="20">
                                        mdi-checkbox-marked-circle
                                    </v-icon>

                                    <numberIcon v-else
                                        class="ml-1 mr-3"
                                        style="min-width: 18px"
                                        :number="ndx+1" 
                                        :numberColor="mod_info.steps_completed+1 == (ndx+1) ? `primary`: ``" />

                                    <div class="flex-grow-1" style="overflow-x:hidden">
                                        <div class="sansation step_title" v-html="stage.stage_name_snippit"></div>
                                        <div class="mt-1 avenir_book step_subtitle" v-html="stage.stage_desc_snippit"></div>
                                    </div>

                                    <v-icon right class="pa-0 ma-0 mr-n2">
                                        mdi-chevron-right
                                    </v-icon>

                                    <div :class="stage.last_stage ? '' : 'step_bottom_border'">&nbsp;</div>
                                </v-tab>
                            
                                <v-tab-item v-for="(stage, ndx) in mod_info.module_stages.filter(stage => !stage.is_independent)" :key="stage.id"
                                    grow
                                    eager
                                    class="pa-8 pb-4 flex-grow-1 flex-column"
                                    transition="none"
                                    reverse-transition="none"
                                    >

                                    <div class="ma-0 pa-0 d-flex flex-column"
                                        :style="`min-height: `+(mod_info.module_stages.filter(stage => !stage.is_independent).length < 4 ? mod_info.module_stages.filter(stage => !stage.is_independent).length * 120 : mod_info.module_stages.filter(stage => !stage.is_independent).length * 80)+`px`">
                                        
                                        <!-- // PROJECT STEP LIST ITEM // -->
                                        <div class="sansation_subtitle ma-0 pa-0 mb-4 align-start">
                                            <span class="mr-3">Step {{ (ndx+1) }}:</span> {{ stage.stage_name }}
                                        </div>

                                        <!-- // PROJECT DESCRIPTION // -->
                                        <div class="avenir_book general_grey--text ma-0 pa-0 stage_desc" 
                                             v-html="stage.stage_desc"
                                             @click="handleDescClick">
                                        </div>

                                        <!-- CURRENT RESOLUTIONS -->

                                        <div class="mt-16" v-if="stage.stage_name.includes('Resolution') && mod_info.subProjects">
                                          <!-- <div v-if="mod_info.subprojects"> -->
                                            <div>Resolutions in progress: </div>
                                                  <div v-for="(subproject, index) in mod_info.subproject.sort((a, b) => (a.date_initialized - b.date_initialized))"
                                                  >
                                                    <router-link
                                                    :to="`/module_resolution/${subproject.module_key}/${subproject.project_id}`" 
                                                    >
                                                      Resolution Submission #{{ index + 1 }}
                                                      <!-- - {{ subproject.project_id }} -->
                                                    </router-link>
                                                  </div>
                                            <!-- <p>mod_info</p> -->
                                        </div>

                                        <div v-if="stage.show_actions" 
                                            class="ma-0 mt-auto pa-0 py-3">
                                            <v-divider class="my-3" color="#E6E7E8"></v-divider>
                                            
                                            <!-- // STEP COMPLETED CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed"
                                                class="float-right"
                                                color="accent"
                                                text-color="primary">
                                                    <v-avatar left>
                                                        <v-icon>mdi-checkbox-marked-circle</v-icon>
                                                    </v-avatar>
                                                    Completed
                                            </v-chip>
                                            
                                            <!-- // NO REVISONS REQUIRED CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'revisions' && !mod_info.revs.length"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    No Revisions
                                            </v-chip>

                                            <!-- // OPT OUT CHIP // -->
                                            <v-chip
                                                v-if="stage.show_completed && stage.stage_type == 'opt_out' && mod_info.optout_details != null"
                                                :active="(stage.show_completed && stage.stage_type == 'opt_out' && mod_info.optout_details != null) || show_optout_chip"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    {{ Object.keys(mod_info.optout_details)[0] == 'entity_binder' ? 'No binder needed' : '' }}
                                            </v-chip>

                                            <!-- // ADVANCE CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'advance'"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                {{ stage.show_advance_label }}
                                            </v-chip>

                                            <!-- // DOC SIGNING CHIP // -->
                                            <v-chip
                                                v-if="stage.show_completed && stage.stage_type == 'doc_signing' && doc_signing_selection != ''"
                                                :active="(stage.show_completed && stage.stage_type == 'doc_signing' && doc_signing_selection != '') || show_doc_signing_chip"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    Signing via {{ doc_signing_selection }}
                                            </v-chip>

                                            <!-- // PROJECT ON HOLD CHIP // -->
                                            <v-chip
                                                :active="mod_info.status.includes('hold') && mod_info.status.includes(stage.id)"
                                                class="float-right"
                                                :class="mod_info.status.includes('hold') && mod_info.status.includes(stage.id) ? 'd-block' : ''"
                                                color="warning"
                                                text-color="white">
                                                    <v-avatar left>
                                                        <v-icon>mdi-alert-circle</v-icon>
                                                    </v-avatar>
                                                    Holding for more info
                                            </v-chip>

                                            <!-- // NO CALL REQUIRED CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'call_option'"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    No Call Necessary
                                            </v-chip>

                                            <!-- // SCHEDULE A CALENDLY CALL // -->
                                            <div v-if="stage.show_calendly">
                                                <div v-if="['call_option', 'call_option_final'].includes(stage.stage_type)" class="d-flex justify-space-between">
                                                    <v-btn 
                                                        v-model="no_call"
                                                        elevation="2"
                                                        color="primary"
                                                        class="justify-start"
                                                        :disabled="calendly_schedule_lock"
                                                        @click="noCallActions(stage.stage_type)">
                                                        <span v-if="calendly_schedule_lock">Meeting Scheduled</span>
                                                        <span v-else>{{ stage.stage_type == 'call_option_final' ? 'Ready for Final Documents' : 'No Call Necessary'}}</span>
                                                    </v-btn>

                                                    <div class="justify-end">
                                                        <v-btn 
                                                            target="_blank"
                                                            elevation="2"
                                                            outlined
                                                            color="primary"
                                                            class="d-block"
                                                            :disabled="calendly_schedule_lock"
                                                            @click="setupCalendly({ url: stage.extra_details, stage_name: stage.stage_name })">
                                                            <span v-if="calendly_schedule_lock">Meeting Scheduled</span>
                                                            <span v-else>Schedule a Call<v-icon right color="white">mdi-calendar</v-icon></span>
                                                        </v-btn>
                                                        <!-- <v-chip
                                                            class="mt-2 pl-4 d-block text-center"
                                                            color="accent"
                                                            text-color="primary">
                                                            <v-icon left class="mr-2">mdi-phone-in-talk</v-icon>
                                                            {{ mod_info.calls_used }} of {{ mod_info.calls_allowed }} calls used
                                                        </v-chip> -->
                                                    </div>
                                                </div>
                                                <div v-else class="d-flex justify-space-between">
                                                    <v-chip
                                                        class="pl-4 justify-start"
                                                        color="accent"
                                                        text-color="primary">
                                                        <v-icon left class="mr-2">mdi-phone-in-talk</v-icon>
                                                        {{ mod_info.calls_used }} of {{ mod_info.calls_allowed }} calls used
                                                    </v-chip>
                                                    <v-btn 
                                                        target="_blank"
                                                        elevation="2"
                                                        color="primary"
                                                        class="justify-end"
                                                        :disabled="calendly_schedule_lock"
                                                        @click="setupCalendly({ url: stage.extra_details, stage_name: stage.stage_name })">
                                                        <span v-if="calendly_schedule_lock">Meeting Scheduled</span>
                                                        <span v-else>Schedule a Call<v-icon right color="white">mdi-calendar</v-icon></span> 
                                                    </v-btn>
                                                </div>
                                            </div>

                                            <!-- // REVISIONS UPLOAD // -->
                                            <div v-if="stage.show_revisions_upload" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="no_revisions"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    label="I don't have any revisions"
                                                    :disabled="mod_info.module_key.includes('-starter') && mod_info.revs.length ? true : false"
                                                    @click="openNoRevisions=true">
                                                </v-checkbox>                                                
                                                
                                                <v-btn  
                                                    color="primary" 
                                                    class="d-inline ml-9"
                                                    @click="uploadRevisionsDialog = true">
                                                    Upload Revisions
                                                </v-btn>
                                            </div>

                                            <!-- // OPT OUT OPTIONS // -->
                                            <div v-if="stage.show_optout_options" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="optout_selection"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    :label="stage.show_optout_statement"
                                                    :disabled="mod_info.module_key.includes('-starter') ? true : false"
                                                    @click="openOptOutConfirmation=true; optOutDetails[stage.extra_details] = stage.show_optout_statement">
                                                </v-checkbox>
                                            </div>

                                            <!-- // DOC SIGNING OPTIONS // -->
                                            <div v-if="stage.show_doc_signing_options" class="justify-end align-center">
                                                <v-radio-group
                                                    v-model="doc_signing_selection"
                                                    column
                                                >
                                                <div v-for="i in JSON.parse(stage.extra_details)" 
                                                    :key="i.value" 
                                                    class="ma-0 pa-0">
                                                    <v-radio 
                                                        color="primary" 
                                                        class="mt-1 general_grey--text"
                                                        :value="i.value"
                                                        @click="openDocSigningConfirmation=true">
                                                        <template v-slot:label><div v-html="i.label"></div></template>
                                                    </v-radio>
                                                </div>
                                                </v-radio-group>
                                            </div>

                                            <!-- // ADVANCE PROJECT // -->
                                            <div v-if="stage.show_advance_project" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="advance_selection"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    :label="JSON.parse(stage.extra_details).label"
                                                    :disabled="mod_info.module_key.includes('-starter') ? true : false"
                                                    @click="openAdvanceProjectConfirmation=true; advanceDetails = JSON.parse(stage.extra_details)">
                                                </v-checkbox>
                                            </div>

                                            <!-- // QUESTIONNAIRE PROGRESS //  -->
                                            <div v-if="!stage.show_completed && (ndx+1) == 1">
                                                <router-link
                                                    :to="`/module_questionnaire/${mod_info.module_key}/${mod_info.project_id}`" 
                                                    push
                                                    @mouseover.native="q_button_hover = true"
                                                    @mouseleave.native="q_button_hover = false"
                                                    style="cursor: pointer">
                                                    <v-progress-linear
                                                        :active="true"
                                                        buffer-value="100"
                                                        height="44"
                                                        rounded
                                                        :value="mod_info.questionnaire_percentage ? mod_info.questionnaire_percentage : mod_info.questionnaire_percentage+.5"
                                                        color="primary"
                                                        class="mt-1 d-block elevation-3">
                                                        <div class="px-4 sansation"
                                                            :class="mod_info.questionnaire_percentage > 10 ? 'white--text' : 'general_grey--text'">
                                                            {{ mod_info.questionnaire_percentage ? mod_info.questionnaire_percentage : 0 }}% complete
                                                        </div>
                                                        <v-spacer></v-spacer>
                                                        <div 
                                                            class="px-4 sansation"  
                                                            :class="mod_info.questionnaire_percentage > 75 ? 'white--text' : 'general_grey--text'"
                                                            style="font-size: 1.1rem !important">
                                                            <span :class="q_button_hover ? 'hover_link ' : ''">continue questionnaire</span>
                                                            <v-icon class="ml-2"
                                                                :color="mod_info.questionnaire_percentage > 75 ? 'white' : 'general_grey'" >
                                                                mdi-arrow-right-bold-circle
                                                            </v-icon>
                                                        </div>
                                                    </v-progress-linear>
                                                </router-link>
                                            </div>

                                            <!-- // SURVEY BUTTON // -->
                                            <v-btn v-if="(ndx+1) == mod_info.last_stage && survey_activated" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Survey
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-tab-item>
                            </v-tabs>
                        </v-card>

                        <div v-else>
                            <div v-if="archived_listings.length" class="d-flex justify-end mb-4 mt-0">
                                <div class="d-inline ml-0 mr-1 sansation">
                                    <a v-if="interest_type != 'current'" class="px-4 projecttype" @click="loadInterests('current')">Current Interest</a>
                                    <div v-if="interest_type == 'current'" class="px-4 projecttype_active">Current Interest</div>
                                </div>
                                <v-divider vertical></v-divider>
                                <div class="d-inline ml-1 mr-0">
                                    <a v-if="interest_type != 'archived'" class="px-4 projecttype" @click="loadInterests('archived')">Archived Interest</a>
                                    <div v-if="interest_type == 'archived'" class="px-4 projecttype_active">Archived Interest</div>
                                </div>
                            </div>

                            <v-card v-for="(buyer, b) in interested_listings"
                                :key="b"
                                class="ma-0 pa-0"
                                :class="`${interested_listings[interested_listings.length-1].lid == buyer.lid || interested_listings.length == 1 ? `mb-10` : `mb-4`}`">

                                <v-hover v-slot="{ hover }">
                                    <div :class="hover ? `elevation-6` : ``">
                                        <v-card-title class="py-2 px-4 d-flex justify-space-between align-center" :class="(buyer.is_archived || buyer.is_disqualified ) ? 'general_grey--text' : 'primary--text'">
                                            <div class="d-inline sansation">
                                                <a @click.stop="openProspectus(buyer)" class="buyers_link">{{ buyer.listing_id }}</a>
                                                <div class="d-inline ml-4 mr-1 general_grey--text text--lighten-3">{{ buyer.practice_type.text }}</div>
                                                <div class="d-inline mx-1 general_grey--text text--lighten-3">::</div>
                                                <div class="d-inline mx-1 general_grey--text text--lighten-3">{{ buyer.accepting_flag ? `Accepting Applications` : `Not Accepting Applications` }}</div>
                                                <div class="d-inline mx-1 general_grey--text text--lighten-3">::</div>
                                                <div class="d-inline mx-1 warning--text text--lighten-1">{{ buyer.status_text }}</div>
                                            </div>
                                            <div class="d-inline general_grey--text sansation">
                                                <div class="d-inline mr-3">
                                                    {{ buyer.status_change_date == null ? 'Expressed Interest:' : 'Status Change:' }}
                                                </div>
                                                <div class="d-inline general_grey--text text--lighten-3">
                                                    {{ buyer.status_change_date == null ? formatDate(buyer.created_date.substr(0,10), 'mmm. dd, yyyy') : formatDate(buyer.status_change_date.substr(0,10), 'mmm. dd, yyyy') }}
                                                </div>
                                            </div>
                                        </v-card-title>

                                        <v-divider class="mb-2"></v-divider>
                                        
                                        <v-card-text class="sansation">
                                            <div class="d-flex justify-space-between">
                                                <div class="d-flex flex-column justify-space-between">
                                                    <div class="d-flex d-block justify-start">
                                                        <div class="">Status:</div>
                                                        <v-chip
                                                            color="accent"
                                                            class="ml-2 mt-n1 text-uppercase general_grey--text">
                                                            {{ buyer.buyer_status.description }}
                                                            <v-tooltip
                                                                v-if="buyer.status_reason"
                                                                bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon 
                                                                        v-on="on"
                                                                        color="general_grey lighten-1"
                                                                        class="ml-2">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <div style="width: 300px" class="px-1 py-2">{{ buyer.status_reason.explaination }}</div>
                                                            </v-tooltip>
                                                        </v-chip>
                                                    </div>
                                                    
                                                    <div v-if="disqualifiedBuyerStatusIds.includes(buyer.status_id) || buyer.is_archived">
                                                        <div v-if="buyer.is_archived === false" class="d-inline pr-9 py-2">
                                                            <a  class="general_grey--text remove_link text-capitalize sansation"
                                                                style="font-size: 1.1rem !important"
                                                                @click="updateListing('is_archived', buyer.lid)">
                                                                Archive Interest
                                                            </a>
                                                        </div>
                                                        <div v-else class="d-inline py-2">
                                                            <span class="general_grey--text text--lighten-3 text-capitalize sansation"
                                                                style="font-size: 1.1rem !important">
                                                                Archived
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div v-else>
                                                        <v-btn 
                                                            small
                                                            outlined 
                                                            color="primary" 
                                                            class="sansation mr-6" 
                                                            href="mailto:buyer@successionresourcegroup.com" 
                                                            target="_blank">
                                                            Request Update <v-icon small color="primary" class="ml-3">mdi-email-outline</v-icon>
                                                        </v-btn>
                                                        
                                                        <div v-if="buyer.is_archived === false" class="d-inline py-2">
                                                            <a  class="general_grey--text remove_link text-capitalize sansation"
                                                                style="font-size: 1.1rem !important"
                                                                @click="updateListing('is_archived', buyer.lid)">
                                                                Archive Interest
                                                            </a>
                                                        </div>
                                                        <div v-else class="d-inline py-2">
                                                            <span class="general_grey--text text--lighten-3 text-capitalize sansation"
                                                                style="font-size: 1.1rem !important">
                                                                Archived
                                                            </span>
                                                        </div>
                                                        
                                                    </div>
                                                </div>

                                                <div class="d-inline">
                                                    <div class="d-block text-right">
                                                        <div class="d-inline sansation">Listing Stage:</div>
                                                        <div class="d-inline general_grey--text text--lighten-3 ml-2">{{ buyer.listing_stage.text }}</div>
                                                    </div>
                                                    <div class="d-block my-3 text-right">
                                                        <div class="d-inline sansation">Asking Price:</div>
                                                        <div class="d-inline general_grey--text text--lighten-3 ml-2">{{ buyer.asking_price }}</div>
                                                    </div>
                                                    <div class="d-block my-3 text-right">
                                                        <div class="d-inline sansation">AUM:</div>
                                                        <div class="d-inline general_grey--text text--lighten-3 ml-2">{{ buyer.aum | currency }}</div>
                                                    </div>
                                                    <div class="d-block mt-3 text-right">
                                                        <div class="d-inline sansation">Revenue:</div>
                                                        <div class="d-inline general_grey--text text--lighten-3 ml-2">{{ buyer.revenue | currency }}</div>
                                                    </div>
                                                    <!-- <div
                                                      v-if="buyer.adjusted_compatibility_score"
                                                      class="d-block mt-3 text-right">
                                                        <div class="d-inline sansation">Compatibility Score:</div>
                                                        <div class="d-inline general_grey--text text--lighten-3 ml-2">{{ buyer.adjusted_compatibility_score }}%</div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </div>
                                </v-hover>
                            </v-card>

                            <v-card v-if="!current_listings.length"
                                elevation="2"
                                class="ma-0 mb-5 pa-0">

                                <v-card-title>You have not expressed interest on any current listings!</v-card-title>
                                <v-card-text>
                                    <div class="d-flex d-block justify-space-between my-4 avenir_medium disclaimer_text_size">
                                        <div v-if="!mod_info.complete" class="d-inline">
                                            There seems to be required field(s) on your profile that have not been answered.<br>
                                            Please take a look and complete your profile.
                                            <div class="d-block mt-8">Here are a few of our hottest seller listings to express interest on!</div>
                                        </div>
                                        <div v-else class="d-inline">
                                            Here are a few of our hottest seller listings to express interest on!
                                        </div>

                                        <router-link
                                            v-if="!mod_info.complete"
                                            :to="`/module_questionnaire/${mod_info.module_key}/${mod_info.project_id}`" 
                                            push
                                            class="primary--text d-inline sansation"
                                            style="text-decoration: none">
                                            <v-btn 
                                                outlined
                                                elevation="2"
                                                class="py-0 px-3 mb-1 text-capitalize" 
                                                color="primary">
                                                Complete Your Profile
                                            </v-btn>
                                        </router-link>
                                    </div>
                                    <v-divider class="mt-2 mb-3"></v-divider>
                                    <DashListings 
                                        direction="horizontal"
                                        :authUser="authUser" />
                                </v-card-text>
                            </v-card>

                        </div>

                        <v-card
                            v-if="mod_info.module_key == 'entity-maintenance-program'"
                            v-for="section in [{stages: primary_independent_stages, label: 'primary'}, {stages: secondary_independent_stages, label: 'secondary'}]" :key="section.label"
                            elevation="2"
                            class="ma-0 mb-5 pa-0">

                            <v-tabs 
                                vertical
                                grow
                                slider-size=4
                                color="primary"
                                class="ma-0 pa-0 general_grey--text"
                                active-class="active_step"
                                v-model="section.stages">

                                <v-tab v-for="stage in section.stages" :key="stage.id"
                                    class="justify-start align-center pl-3 py-3"
                                    style="border-right: 2px solid #EFEFEF; width:300px"
                                    :style="mod_info.last_stage == stage.stage_order ? '' : 'border-bottom:1px solid #EFEFEF'">
                                    
                                    <v-icon v-if="stage.completed_val"
                                        color="secondary" 
                                        class="ml-1 mr-3" 
                                        size="20">
                                        mdi-checkbox-marked-circle
                                    </v-icon>

                                    <div v-if="!stage.completed_val"
                                        class="ml-1 mr-7"
                                    />

                                    <div class="flex-grow-1" style="overflow-x:hidden;">
                                        <div class="sansation step_title" v-html="stage.stage_name_snippit"></div>
                                        <div class="mt-1 avenir_book step_subtitle" v-html="stage.stage_desc_snippit"></div>
                                    </div>

                                    <v-icon right class="pa-0 ma-0 mr-n2">
                                        mdi-chevron-right
                                    </v-icon>

                                    <div :class="stage.last_stage ? '' : 'step_bottom_border'">&nbsp;</div>
                                </v-tab>
                            
                                <v-tab-item v-for="stage in section.stages" :key="stage.id"
                                    grow
                                    eager
                                    class="pa-8 pb-4 flex-grow-1 flex-column"
                                    transition="none"
                                    reverse-transition="none">

                                    <div
                                        class="ma-0 pa-0 d-flex flex-column"
                                        
                                        :style="section.label === 'secondary'? 'min-height: 750px': ''">
                                        
                                        <!-- // PROJECT STEP LIST ITEM // -->
                                        <div class="sansation_subtitle ma-0 pa-0 mb-4 align-start">
                                            {{ stage.stage_name }}
                                        </div>

                                        <!-- // PROJECT DESCRIPTION // -->
                                        <div class="avenir_book general_grey--text ma-0 pa-0 stage_desc" 
                                             v-html="stage.stage_desc"
                                             @click="handleDescClick">
                                        </div>

                                        <!-- CURRENT RESOLUTIONS -->
                                        <div class="avenir_book mt-10" v-if="stage.stage_name.includes('Resolution') && mod_info.subProjects">
                                            <div>Resolutions:</div>
                                            <div v-for="(subProject, index) in mod_info.subProjects">
                                                <router-link
                                                :to="`/module_resolution/${subProject.module_key}/${subProject.project_id}`" 
                                                >
                                                    Resolution - {{ subProject.date_initialized.substr(0,10)}} ({{ subProject.status === 'open' ? "Open" : "Submitted" }})
                                                </router-link>
                                            </div>
                                        </div>

                                        <div v-if="stage.show_actions || stage.is_independent" 
                                            class="ma-0 mt-auto pa-0 py-3">
                                            <v-divider class="my-3" color="#E6E7E8"></v-divider>
                                            
                                            <!-- // STEP COMPLETED CHIP // -->
                                            <v-chip
                                                v-if="stage.stage_order != 1"
                                                :active="stage.completed_val"
                                                class="float-right"
                                                color="accent"
                                                text-color="primary">
                                                    <v-avatar left>
                                                        <v-icon>mdi-checkbox-marked-circle</v-icon>
                                                    </v-avatar>
                                                    Completed
                                            </v-chip>
                                            
                                            <!-- // NO REVISONS REQUIRED CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'revisions' && !mod_info.revs.length"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    No Revisions
                                            </v-chip>

                                            <!-- // OPT OUT CHIP // -->
                                            <v-chip
                                                v-if="stage.show_completed && stage.stage_type == 'opt_out' && mod_info.optout_details != null"
                                                :active="(stage.show_completed && stage.stage_type == 'opt_out' && mod_info.optout_details != null) || show_optout_chip"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    {{ Object.keys(mod_info.optout_details)[0] == 'entity_binder' ? 'No binder needed' : '' }}
                                            </v-chip>

                                            <!-- // ADVANCE CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'advance'"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                {{ stage.show_advance_label }}
                                            </v-chip>

                                            <!-- // PROJECT ON HOLD CHIP // -->
                                            <v-chip
                                                :active="mod_info.status.includes('hold') && mod_info.status.includes(stage.id)"
                                                class="float-right"
                                                :class="mod_info.status.includes('hold') && mod_info.status.includes(stage.id) ? 'd-block' : ''"
                                                color="warning"
                                                text-color="white">
                                                    <v-avatar left>
                                                        <v-icon>mdi-alert-circle</v-icon>
                                                    </v-avatar>
                                                    Holding for more info
                                            </v-chip>

                                            <!-- // NO CALL REQUIRED CHIP // -->
                                            <v-chip
                                                :active="stage.show_completed && stage.stage_type == 'call_option'"
                                                class="mr-5 float-right"
                                                color="general_lightgrey"
                                                text-color="primary">
                                                    No Call Necessary
                                            </v-chip>

                                            <!-- // SCHEDULE A CALENDLY CALL // -->
                                            <div v-if="stage.show_calendly">
                                                <div v-if="stage.stage_type == 'call_option'" class="d-flex justify-space-between">
                                                    <v-btn 
                                                        v-model="no_call"
                                                        elevation="2"
                                                        color="primary"
                                                        class="justify-start"
                                                        :disabled="calendly_schedule_lock"
                                                        @click="openNoCall=true">
                                                        Ready for Final Documents
                                                    </v-btn>

                                                    <div class="justify-end">
                                                        <v-btn 
                                                            target="_blank"
                                                            elevation="2"
                                                            outlined
                                                            color="primary"
                                                            class="d-block"
                                                            :disabled="calendly_schedule_lock"
                                                            @click="setupCalendly({ url: stage.extra_details, stage_name: stage.stage_name })">
                                                            <span v-if="calendly_schedule_lock">Meeting Scheduled</span>
                                                            <span v-else>Schedule a Call<v-icon right color="white">mdi-calendar</v-icon></span>
                                                        </v-btn>
                                                        <!-- <v-chip
                                                            class="mt-2 pl-4 d-block text-center"
                                                            color="accent"
                                                            text-color="primary">
                                                            <v-icon left class="mr-2">mdi-phone-in-talk</v-icon>
                                                            {{ mod_info.calls_used }} of {{ mod_info.calls_allowed }} calls used
                                                        </v-chip> -->
                                                    </div>
                                                </div>
                                                <div v-else class="d-flex justify-space-between">
                                                    <v-chip
                                                        class="pl-4 justify-start"
                                                        color="accent"
                                                        text-color="primary">
                                                        <v-icon left class="mr-2">mdi-phone-in-talk</v-icon>
                                                        {{ mod_info.calls_used }} of {{ mod_info.calls_allowed }} calls used
                                                    </v-chip>
                                                    <v-btn 
                                                        target="_blank"
                                                        elevation="2"
                                                        color="primary"
                                                        class="justify-end"
                                                        :disabled="calendly_schedule_lock"
                                                        @click="setupCalendly({ url: stage.extra_details, stage_name: stage.stage_name })">
                                                        <span v-if="calendly_schedule_lock">Meeting Scheduled</span>
                                                        <span v-else>Schedule a Call<v-icon right color="white">mdi-calendar</v-icon></span>
                                                    </v-btn>
                                                </div>
                                            </div>

                                            <!-- // REVISIONS UPLOAD // -->
                                            <div v-if="stage.show_revisions_upload" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="no_revisions"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    label="I don't have any revisions"
                                                    :disabled="mod_info.module_key.includes('-starter') && mod_info.revs.length ? true : false"
                                                    @click="openNoRevisions=true">
                                                </v-checkbox>
                                                
                                                <v-btn  
                                                    color="primary" 
                                                    class="d-inline ml-9"
                                                    :disabled="mod_info.revs.length ? true : false"
                                                    @click="uploadRevisionsDialog = true">
                                                    Upload Revisions
                                                </v-btn>
                                            </div>

                                            <!-- // OPT OUT OPTIONS // -->
                                            <div v-if="stage.show_optout_options" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="optout_selection"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    :label="stage.show_optout_statement"
                                                    :disabled="mod_info.module_key.includes('-starter') ? true : false"
                                                    @click="openOptOutConfirmation=true; optOutDetails[stage.extra_details] = stage.show_optout_statement">
                                                </v-checkbox>
                                            </div>

                                            <!-- // ADVANCE PROJECT // -->
                                            <div v-if="stage.show_advance_project" class="d-flex justify-end align-center">
                                                <v-checkbox 
                                                    v-model="advance_selection"
                                                    hide-details
                                                    color="primary" 
                                                    class="ma-0 pa-0 general_grey--text"
                                                    :label="JSON.parse(stage.extra_details).label"
                                                    :disabled="mod_info.module_key.includes('-starter') ? true : false"
                                                    @click="openAdvanceProjectConfirmation=true; advanceDetails = JSON.parse(stage.extra_details)">
                                                </v-checkbox>
                                            </div>

                                            <!-- // QUESTIONNAIRE PROGRESS //  -->
                                            <div v-if="!stage.show_completed && stage.stage_order == 1">
                                                <router-link
                                                    :to="`/module_questionnaire/${mod_info.module_key}/${mod_info.project_id}`" 
                                                    push
                                                    @mouseover.native="q_button_hover = true"
                                                    @mouseleave.native="q_button_hover = false"
                                                    style="cursor: pointer">
                                                    <v-progress-linear
                                                        :active="true"
                                                        buffer-value="100"
                                                        height="44"
                                                        rounded
                                                        :value="mod_info.questionnaire_percentage ? mod_info.questionnaire_percentage : mod_info.questionnaire_percentage+.5"
                                                        color="primary"
                                                        class="mt-1 d-block elevation-3">
                                                        <div class="px-4 sansation"
                                                            :class="mod_info.questionnaire_percentage > 10 ? 'white--text' : 'general_grey--text'">
                                                            {{ mod_info.questionnaire_percentage ? mod_info.questionnaire_percentage : 0 }}% complete
                                                        </div>
                                                        <v-spacer></v-spacer>
                                                        <div 
                                                            class="px-4 sansation"  
                                                            :class="mod_info.questionnaire_percentage > 75 ? 'white--text' : 'general_grey--text'"
                                                            style="font-size: 1.1rem !important">
                                                            <span :class="q_button_hover ? 'hover_link ' : ''">continue questionnaire</span>
                                                            <v-icon class="ml-2"
                                                                :color="mod_info.questionnaire_percentage > 75 ? 'white' : 'general_grey'" >
                                                                mdi-arrow-right-bold-circle
                                                            </v-icon>
                                                        </div>
                                                    </v-progress-linear>
                                                </router-link>
                                            </div>

                                            <!-- // RESOLUTIONS PROGRESS //  -->
                                            <div v-if="stage.stage_name.includes('Resolution') && showResolutions">
                                            <div
                                                @click="addResolution(mod_info)"
                                                @mouseover="r_button_hover = true"
                                                @mouseleave="r_button_hover = false"
                                                style="cursor: pointer">
                                                <v-progress-linear
                                                    :active="true"
                                                    buffer-value="100"
                                                    height="44"
                                                    rounded
                                                    :value="mod_info.subProjects ? (mod_info.subProjects.length / 10) * 100 : 0"
                                                    color="primary"
                                                    class="mt-1 d-block elevation-3">
                                                    <div class="px-4 sansation"
                                                        :class="mod_info.questionnaire_percentage > 10 ? 'white--text' : 'general_grey--text'">
                                                        {{ mod_info.subProjects ? mod_info.subProjects.length : 0 }} out of 10 completed
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                    <div 
                                                        class="px-4 sansation"  
                                                        :class="mod_info.questionnaire_percentage > 75 ? 'white--text' : 'general_grey--text'"
                                                        style="font-size: 1.1rem !important">
                                                        <span :class="r_button_hover ? 'hover_link ' : ''">make resolution</span>
                                                        <v-icon class="ml-2"
                                                            :color="!mod_info.resolutions_data ? 'general_grey' : Object.keys(mod_info.resolutions_data).length > 7 ? 'white' : 'general_grey'" >
                                                            mdi-arrow-right-bold-circle
                                                        </v-icon>
                                                    </div>
                                                </v-progress-linear>
                                                </div>
                                            </div>


                                            <!-- // Annual Report // -->

                                            <!-- <v-btn v-if="stage.is_independent && stage.stage_name === 'Annual Report'" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Annual Report
                                            </v-btn> -->

                                            <!-- // Annual Member or Shareholder // -->

                                            <!-- <v-btn v-if="stage.is_independent && stage.stage_name === 'Annual Member or Shareholder Meeting Support'" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Annual Member or Shareholder Meeting Support
                                            </v-btn> -->


                                              <!-- // Subscription Update // -->

                                              <!-- <v-btn v-if="stage.is_independent && stage.stage_name === 'Subscription Update'" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Subscription Update
                                            </v-btn> -->



                                            <v-btn v-if="stage.is_independent && stage.stage_type === 'survey'" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Survey
                                            </v-btn>


                                            <!-- // SURVEY BUTTON // -->
                                            <v-btn v-if="stage.stage_order == mod_info.last_stage && survey_activated" 
                                                color="primary" 
                                                class="float-right"
                                                :disabled="mod_info.disable_survey"
                                                @click="surveyDialog = true">
                                                Survey
                                            </v-btn>
                                        </div>
                                    </div>                                    
                                </v-tab-item>
                            </v-tabs>
                        </v-card>

                        <!-- RESOURCES -->
                        <v-card v-if="mod_info.resource_visibility && mod_info.resource_visibility.filter(file => file.is_visible).length" 
                            elevation="2"
                            class="ma-0 mt-5 pa-0 pb-10 flex-grow-1">
                            
                            <div class="pa-4 d-flex align-center">
                                <div class="sansation_subtitle d-inline flex-grow-1">Resources</div>
                            </div>

                            <div class="pa-4 mb-6 sansation">
                                <ProjectResources
                                    :projectResources="mod_info"
                                    @playResourceVideo="playResourceVideo" />
                            </div>
                        </v-card>
                        
                        <!-- DOCUMENTS -->
                        <v-card 
                            elevation="2"
                            class="ma-0 mt-5 pa-0 flex-grow-1"
                            :class="(mod_info.access_deliverables && mod_info.dlvs.length) || (mod_info.docs.length || mod_info.revs.length) ? 'pb-4' : ''">

                            <div class="pa-4 d-flex align-center justify-space-between">
                                <div class="sansation_subtitle d-inline align-center flex-grow-1">
                                    Documents 
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <img :src="awslogo" atl="Powered by Amazon S3 Secure Cloud-Based Storage" class="aws_logo ml-4" v-bind="attrs" v-on="on" />
                                        </template>
                                        <div>Powered by Amazon S3 Secure Cloud-Based Storage</div>
                                    </v-tooltip>
                                </div>
                                <div class="sansation_subtitle d-inline align-center justify-end">
                                    <div class="sansation d-inline text-uppercase"><a @click="disclaimerDialog = true" class="disclaimer_link_size text-decoration-underline">disclaimer</a></div>
                                    <v-btn
                                        v-if="mod_info.upload_independent_docs"
                                        small
                                        elevation=3
                                        color="primary"
                                        class="d-inline ml-4"
                                        @click="uploadIndependentDocsDialog = true">
                                        Upload Document(s)
                                    </v-btn>
                                </div>
                            </div>

                            <div v-if="mod_info.access_deliverables && mod_info.dlvs.length" class="pa-4 pb-0 mb-6 sansation">
                                <ProjectDeliverables
                                    :projectDeliverables="mod_info"
                                    :refresh_delivs="refresh_delivs"
                                    @pullProjectDelivs="pullProjectDelivs"
                                    @confirmedDeliverable="confirmedDeliverable" />
                            </div>
                            
                            <div v-if="mod_info.partner_docs.length && ['nm_partner_firm'].includes(authUser.group)" class="pa-4 pb-0 sansation">
                                <ProjectPartnerDocs
                                    :projectDetails="mod_info"
                                    :refresh_docs="refresh_docs"
                                    @pullProjectDocs="pullProjectDocs" />
                            </div>

                            <div v-if="mod_info.docs.length || mod_info.revs.length" class="pa-4 pb-0 sansation">
                                <ProjectFiles
                                    :projectDetails="mod_info"
                                    :refresh_docs="refresh_docs"
                                    @pullProjectDocs="pullProjectDocs" />
                            </div>
                        </v-card>

                        <!-- USERS -->
                        <v-card v-if="!mod_info.secondary_access"
                                elevation="2"
                                class="ma-0 mt-5 pa-0 flex-grow-1" 
                                :class="mod_info.users.length ? 'pb-4' : ''">

                            <div class="pa-4 d-flex align-center justify-space-between">
                                <div class="sansation_subtitle d-inline flex-grow-1">
                                    Users
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-3"
                                                color="primary">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span v-html="userStatement"></span>
                                    </v-tooltip>
                                </div>

                                <v-btn
                                    v-if="owner_ids.includes(authUser.id)"
                                    small
                                    outlined
                                    elevation=0
                                    color="primary lighten-1"
                                    class="d-inline justify_end"
                                    :disabled="mod_info.is_archived"
                                    @click="addSecondaryUser(mod_info)">
                                    Add User
                                </v-btn>
                            </div>

                            <ProjectUsers
                                :projectDetails="mod_info"
                                :authUser="authUser"
                                @refreshUsers="refreshUsers" />
                        </v-card>

                        <!-- TEAM INFO -->
                        <ModuleTeamInfo 
                            v-if="readyToLoad && !showTeamVertical"
                            :moduleInfo="mod_info"
                            orientation="horizontal"
                            :isBuyer="mod_info.module_key == 'buyer' ? true : false"
                            :readyToLoadTeam="readyToLoadTeam" />
                    </div>
                </v-col>

                <v-col cols="3" class="ma-0 ml-0 fill-height">
                    <!-- PROJECT STATUS -->
                    <ProjectStatus 
                        :projectDetails="mod_info"
                        :authUser="authUser"
                        :secondaryUserDialog="secondaryUserDialog"
                        :readyToLoadTeam="readyToLoadTeam" />
                    
                    <!-- EXPEDITE INFO -->
                    <ExpediteProject 
                        v-if="this.mod_info.can_expedite && readyToLoad && !this.mod_info.expedite && this.mod_info.expedited_cost != null &&
                            ( !this.mod_info.status.includes('complete') || !this.mod_info.is_archived )"
                        :moduleInfo="mod_info"
                        @getCurrentProject="getCurrentProject" />

                    <!-- TEAM INFO -->
                    <ModuleTeamInfo 
                        v-if="readyToLoad && showTeamVertical"
                        :moduleInfo="mod_info"
                        orientation="vertical"
                        :isBuyer="mod_info.module_key == 'buyer' ? true : false"
                        :readyToLoadTeam="readyToLoadTeam" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import dateFormat, { masks } from "dateformat";
    import { capitalizeFirstWord, numberToWord } from './utilities'
    import awsLogo from '../assets/awsLogo_S3_black.png';

    import ProjectUsers from './ProjectUsers';
    import ProjectStatus from './ProjectStatus';
    import ProjectFiles from './ProjectFiles';
    import ProjectPartnerDocs from './ProjectPartnerDocs';
    import ProjectDeliverables from './ProjectDeliverables';
    import ProjectResources from './ProjectResources';
    import ModuleTeamInfo from './ModuleTeamInfo';
    import SecondaryUser from './SecondaryUser';
    import DashListings from './DashListings';
    import ExpediteProject from './ExpediteProject';
    import UploadDocs from './data_table_forms/file-upload';

    import VideoPlayer from './video';

    const calendlyListeners = [];

    export default {
        name: 'ModuleOverviewInfo',
        
        components: {
            ProjectUsers,
            ProjectStatus,
            ProjectFiles,
            ProjectPartnerDocs,
            ProjectDeliverables,
            ProjectResources,
            ModuleTeamInfo,
            SecondaryUser,
            DashListings,
            ExpediteProject,
            UploadDocs,
            VideoPlayer
        },

        computed: {
            activeStage () {
                return this.mod_info.module_stages[this.mod_info.steps_completed];
            },
            calendly_schedule_lock () {
                return !!this.currentStageMeeting;
            },
            primary_independent_stages () {
                const independent = this.mod_info.module_stages.filter(stage => stage.is_independent);
                const primary = independent.filter(stage => !!stage.is_primary);
                return primary;
            },
            secondary_independent_stages () {
                const independent = this.mod_info.module_stages.filter(stage => stage.is_independent);
                const secondary = independent.filter(stage => !stage.is_primary);
                return secondary;
            },
            showResolutions () {
                // let showRes = this.mod_info.module_stages[0].completed_val === true;
                // return showRes;
                // SB. KG asked for Resolution button to always show
                return true;
            },

        },

        data () {
            return {
                origin: window.location.origin,
                awslogo: awsLogo,
                project_id: this.$route.params.pid,
                alertDialog: false,
                alertMessage: '',
                alertColor: 'secondary darken-2',
                alertDuration: 8000,
                readyToLoad: false,
                readyToLoadTeam: false,
                showTeamVertical: false,
                mod_info: [],
                survey_team_images: [],
                valid: false,
                show_status_reason: false,
                survey_activated: false,
                surveyDialog: false,
                disclaimerDialog: false,
                uploadIndependentDocsDialog: false,
                videoDialog: null,
                videoUrl: '',
                videoSrc: '',
                videoType: '',
                videoTitle: 'Resource Video',
                videoValid: null,
                activateVideoRes: [],
                calendlyDialog: false,
                calendly_url: '',
                calendly_mtg_label: '',
                currentStageMeeting: undefined,
                no_call: false,
                noCallType: '',
                openNoCall: false,
                uploadRevisionsDialog: false,
                openNoRevisions: false,
                no_revisions: false,
                noRevisionsComplete: false,
                no_revision_complete_review: '',
                optout_selection: false,
                show_optout_chip: false,
                openOptOutConfirmation: false,
                optOutDetails: {},
                doc_signing_selection: '',
                show_doc_signing_chip: false,
                openDocSigningConfirmation: false,
                advance_selection: false,
                advanceDetails: {},
                openAdvanceProjectConfirmation: false,
                advance_to_complete: false,
                show_timeliness_feedback: false,
                show_professionalism_feedback: false,
                text_timeliness_feedback: {
                    perfect: 'Please let us know what we did to earn a “Perfect” score for timeliness and delivery. (optional)',
                    improve: 'Please let us know how we can improve our timeliness and delivery to receive a “Perfect” score. (optional)'
                },
                text_professionalism_feedback: {
                    perfect: 'Please let us know what we did to earn a “Perfect” score for communication, accessibility, professionalism and interaction. (optional)',
                    improve: 'Please let us know how we can improve our level of communication, accessibility, professionalism and interaction to receive a “Perfect” score. (optional)'
                },
                surveydata: {
                    timeliness: '',
                    timeliness_feedback: '',
                    professionalism: '',
                    professionalism_feedback: '',
                    fees: '',
                    recommend: '',
                    learn: '',
                    comments_feedback: '',
                    permission: false,
                    reference: false,
                    client_name: '',
                    module_name: ''
                },
                surveyThanks: false,
                survey_clientname: Cookie.get('name').split(' ').shift(),
                //intro_active: true,
                refresh_delivs: false,
                refresh_docs: false,
                authUser: {
					id: String,
                    group: String
				},
                secondaryUserDialog: false,
                userStatement: `Please feel free to add other members of your team as a User that you would like to have access to<br>your myCompass account and/or projects, such as a CPA, attorney, or administrative assistant.`,
                owner_ids: [],
				parentUserId: String,
				secondaryProject: Object,
				show_addedUsers: false,
				show_addUserFeedback: false,
				added_user_feedback: '',

				thisUser: {
					user_id: null,
                    newuser_firstname: '',
                    newuser_lastname: '', 
                    newuser_email: '',
                    user_permissions: ['r','w'],
                    never_expires: true,
                    expiration_date: '',
                    user_type: 'secondary'
                },
				resetCreateNewUser: false,

				admin_header: [
                    {   text: 'Full Name', value: 'first_name', align: 'start', width:'', sortable: true },
                    {   text: 'Phone', value: 'phone', align: 'left', width:'', sortable: true },
                    {   text: 'Email', value: 'user_email', align: 'left', width:'', sortable: true },
                ],
                interested_listings: [],
                current_listings: [],
                archived_listings: [],
                disqualifiedBuyerStatusIds: [],
                interest_type : 'current',
                gatheringInterests: false,
                q_button_hover: false,
                r_button_hover: false,
                independentStageList: [],
                dependentStageList: [],
                sellerScore: 0,
                formulas: {
                    investmentPhilosophy: .1124,
                    clientPhilosophy: .1011,
                    expansionCapacity: .1011,
                    industryExperience: .0899,
                    brokerDealerCustodianTAMP: .0787,
                    officeInfrastrucfture: .0787,
                    financialPlanning: .0674,
                    teamSize: .0674,
                    designations: .0562,
                    proximity: .0449,
                    affiliations: .0449,
                    confidence: .0449,
                    trustworthiness: .0337,
                    reputation: .0225,
                    wow: .0225,
                    officeLocation: .0225,
                    personalityFit: .0112
                },
                no_revision_advance_x2: ['deal-support-starter','deal-support-premium','deal-support-elite'],
                googleReviewLink: 'https://g.page/r/CV20OlCV2OOVEB0/review',
                show_google_review: false
            }
        },

        watch: {
            readyToLoad (val) {
                if ( val ) {
                    this.showTeamVertical = Boolean( (this.mod_info.module_key != 'buyer' && this.mod_info.module_stages.length > 12) || this.mod_info.docs.length || this.mod_info.dlvs.length || this.mod_info.resources.length || this.mod_info.users.length )
                }
            }
            // revision_opportunities (val) {
            //     this.advance_to_complete = val.length > 1 || (this.mod_info.module_stages.length - this.mod_info.steps_completed) > 2 ? false : true
            // }
        },
        
        mounted: async function () {
            await this.getInitData();
            await this.setupCalendlyListener();

            setTimeout(() => { this.surveyCheck() }, 1000)
        },

        methods: {
            getInitData: async function () {
				try {
                    await this.checkUser();
                    
                    await this.getCurrentProject();
                    this.owner_ids = this.mod_info.users.filter( owner => { return owner.user_type == 'owner' } ).map( usr => usr.user_id )
                    
                    if ( this.mod_info.module_key == 'buyer' ) {
                        await this.getListingsForBuyer();
                    }
                    
                    if (this.mod_info.module_key == 'entity-maintenance-program') {
                        await this.getSubProjects(this.mod_info.project_id);
                    }
                    
                    this.getDisqualifiedBuyerStatusIds();
                    this.checkScheduledMeetings();
    
                } catch ( error ) {
                    console.log(error);
                };
			},

            checkUser: async function () {
                try {    
                    const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( user_check.data.outcome ) {    
						this.authUser.id = user_check.data.user_data.id
                        this.authUser.group = user_check.data.user_data.group
                    } else {
						console.log(user_check.data.message)
					}
                } catch ( error ) {
                    console.log(error);
                }
			},

            checkScheduledMeetings: async function () {
                const scheduledMeetings = await axios.get(`${appUrls.api}/api/project/${this.project_id}/meeting`, {
                    headers: { 
                        authentication: Cookie.get('token'), "Content-Type": "application/json" 
                    }
                });

                if ( scheduledMeetings.data.length ) {
                    const currentStageMeeting = scheduledMeetings.data.find( (meeting) => {
                        return meeting.modulestage_id == this.activeStage.id && meeting.status !== 'cancelled'; 
                    });

                    this.currentStageMeeting = currentStageMeeting;
                }
            },

            formatDate: function ( date, mask ) {
                if ( date == null ) return `N/A`

                return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            },

            showGoogleReview: function (val) {
                if ( val == 'Yes' ) {
                    this.show_google_review = true
                }
            },

            openProspectus: async function ( item ) {
                let route = this.$router.resolve({ path: `/buyer_listings/${item.listing_id}`});
                window.open(route.href, '_self');
            },

            setupCalendlyListener() {
                // Remove any existing listeners
                calendlyListeners.forEach((listener, i) => {
                    window.removeEventListener('message', listener);
                    calendlyListeners.splice(i, 1);
                });

                // Add a new listener in this context and track it
                window.addEventListener('message', this.receiveCalendlyMessage);
                calendlyListeners.push(this.receiveCalendlyMessage);
            },

            async receiveCalendlyMessage (event) {
                /**
                 * {
                    event: "calendly.event_scheduled",
                    payload: {
                        event: {
                        uri: "https://api.calendly.com/scheduled_events/ABCDABCDABCDABCD"
                        },
                        invitee: {
                        uri: "https://api.calendly.com/api/v2/scheduled_events/ABCDABCDABCDABCD/invitees/ABCDABCDABCDABCD"
                        }
                    }
                    }
                 */

                const { data } = event;
                const { event: eventType, payload } = data;
                // Ensure the message is from the Calendly iframe
                if (!eventType || eventType.indexOf('calendly') < 0) {
                    return;
                }

                if (eventType === 'calendly.event_scheduled') {
                    const calendly_event_id = payload.event.uri.split('/').pop();
                    const calendly_invitee_id = payload.invitee.uri.split('/').pop();

                    const newMeeting = await axios.post(`${appUrls.api}/api/project/${this.project_id}/meeting`, {
                            calendly_invitee_id,
                            calendly_event_id,
                            modulestage_id: this.activeStage.id,
                            status: 'scheduled',
                            label: this.calendly_mtg_label
                        }, {
                        headers: { 
                            authentication: Cookie.get('token'), 
                            "Content-Type": "application/json" 
                        }
                    });

                    // Update the current scheduled meeting info
                    this.checkScheduledMeetings();
                }

                // Do something with the received data (e.g., the selected date)
                // console.log('Received Calendly Data:', eventType, payload);
            },
            
            surveyCheck: async function () {
                const files_received = this.mod_info.dlvs && this.mod_info.dlvs != undefined ? this.mod_info.dlvs.find( file => file.received != null ) ? true : false : false
                
                if ( !this.mod_info.disable_survey && this.survey_activated && files_received ) {
                    this.surveyDialog = true
                }
            },

            cancelNoRevisions: function () {
                this.no_revisions = false
                this.openNoRevisions = false
            },
            independentDocsUpload: async function () {
                this.uploadIndependentDocsDialog = false;
                this.addUserFeedback({ outcome: true, message: 'Your file(s) have been successfully uploaded!' });
                this.getCurrentProject()
                // this.pullProjectDocs( this.mod_info )
            },
            wrapupRevisionsUpload: async function () {
                this.uploadRevisionsDialog = false;
                const steps_to_advance = 1 // THIS COULD BE CHANGED TO ACCOMODATE DIFFEREMT NEEDS FOR DIFFERENT MODULES
                this.advanceProjectStep( this.mod_info, steps_to_advance, 'revision_uploaded' )
                this.getCurrentProject()
                // this.pullProjectDocs( this.mod_info )
            },
            confirmNoRevisions: async function () {
                const steps_to_advance = this.no_revision_advance_x2.includes(this.mod_info.module_key) ? 2 : 1 // THIS COULD BE CHANGED TO ACCOMODATE DIFFERENT NEEDS FOR DIFFERENT MODULES
                this.advanceProjectStep( this.mod_info, steps_to_advance, 'no_revisions' )
                this.openNoRevisions = false;
                if ( this.advance_to_complete ) {
                    this.noRevisionsComplete = true
                    this.no_revision_complete_review = this.mod_info.module_stages[this.mod_info.module_stages.length-2].stage_desc
                }
            },

            noCallActions: async function ( no_call_type ) {
                this.openNoCall=true
                this.noCallType = no_call_type.includes('final') ? 'no_call_final' : 'no_call'
            },
            cancelNoCalls: function () {
                this.no_call = false
                this.openNoCall = false
                this.noCallType = ''
            },
            confirmNoCall: async function () {
                const steps_to_advance = 1 // THIS COULD BE CHANGED TO ACCOMODATE DIFFEREMT NEEDS FOR DIFFERENT MODULES
                this.advanceProjectStep( this.mod_info, steps_to_advance, this.noCallType )
                this.openNoCall = false;
                this.noCallType = ''
            },

            cancelOptOut: function () {
                this.optout_selection = false
                this.openOptOutConfirmation = false
            },
            confirmOptOut: async function () {
                const steps_to_advance = 1 // THIS COULD BE CHANGED TO ACCOMODATE DIFFEREMT NEEDS FOR DIFFERENT MODULES
                const action_key = 'opt_out-'+Object.keys(this.optOutDetails)[0]
                this.advanceProjectStep( this.mod_info, steps_to_advance, action_key )
                this.openOptOutConfirmation = false;
                this.optout_selection = false;
                this.show_optout_chip = true;
            },

            cancelAdvance: function () {
                this.advance_selection = false
                this.openAdvanceProjectConfirmation = false
            },
            confirmAdvance: async function () {
                const steps_to_advance = 1 // THIS COULD BE CHANGED TO ACCOMODATE DIFFEREMT NEEDS FOR DIFFERENT MODULES
                const action_key = 'advance'
                this.advanceProjectStep( this.mod_info, steps_to_advance, action_key )
                this.openAdvanceProjectConfirmation = false;
                this.advance_selection = false;
                this.show_advance_chip = true;
            },

            cancelDocSigningSelection: function () {
                this.doc_signing_selection = ''
                this.openDocSigningConfirmation = false
            },
            confirmDocSigningSelection: async function () {
                const steps_to_advance = 1
                const action_key = 'doc_signing-'+this.doc_signing_selection
                this.advanceProjectStep( this.mod_info, steps_to_advance, action_key )
                this.openDocSigningConfirmation = false
                this.show_doc_signing_chip = true;
            },

            advanceProjectStep: async function ( prj, steps_to_advance, action) {
                try {
                    const step_count = prj.steps_completed + steps_to_advance;
                    const project_status = step_count == (prj.steps_to_complete) ? 'complete' : prj.status
                    
                    let email_key = ''
                    if ( action == 'no_revisions' ) {
                        email_key = step_count == (prj.steps_to_complete) ? 'no_revisions_complete' : 'no_revisions'
                    } else if ( action.includes('no_call') || action.includes('opt_out') || action.includes('revision_uploaded') || action.includes('doc_signing') || action.includes('advance')) {
                        email_key = action
                    }

                    const update_prj_steps = await axios.put(`${appUrls.api}/api/project_status/${prj.project_id}/${step_count}/${project_status}/${email_key}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( update_prj_steps.data.outcome ) {
                        this.getCurrentProject()
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            getDisqualifiedBuyerStatusIds: async function () {
                try {
                    const get_res = await axios.get(`${appUrls.api}/api/disqualified_ids`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( get_res.data.outcome ) {
                        this.disqualifiedBuyerStatusIds = get_res.data.disqualified_ids
                    }
                } catch ( err ) {
                    console.log(err);
                }
            },
            
            closeSecondary: async function () {
				this.parentUserId = ''
				this.resetCreateNewUser = true
                this.secondaryUserDialog = false
            },

            addSecondaryUser: async function ( prj ) {
				this.secondaryUserDialog = true
				this.parentUserId = prj.user_id
				this.secondaryProject = prj
			},

            addUserFeedback: async function ( rs ) {
				this.secondaryUserDialog = false
				this.alertDialog = true
				this.alertMessage = rs.message
			},

            getCurrentProject: async function () {
                try { 
                    const current_project = await axios.get(`${appUrls.api}/api/current_project/${this.project_id}/${this.authUser.id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })

                    // console.log(current_project.data.details)
                    if ( current_project.data.outcome ) {
                        this.mod_info = await current_project.data.details;

                        if ( this.mod_info.module_key != 'buyer' ) {
                            this.mod_info.last_stage = Object.keys(this.mod_info.module_stages).length
                            this.mod_info.steps_completed = parseInt(this.mod_info.steps_completed)
                            this.survey_activated = this.mod_info.steps_completed >= parseInt(this.mod_info.steps_to_complete) ? true : false;

                            const all_docs = this.mod_info.docs
                            this.mod_info.revs = all_docs.filter( file => file.is_revision === true )
                            this.mod_info.docs = all_docs.filter( file => file.is_revision === false )

                            for ( let [ndx, this_stage] of this.mod_info.module_stages.entries() ) {
                                this.mod_info.module_stages[ndx].stage_name_snippit = this.mod_info.module_stages[ndx].stage_name.substr(0, 31)
                                this.mod_info.module_stages[ndx].stage_desc_snippit = this.mod_info.module_stages[ndx].stage_desc.substr(0, 33)+' ...'
                                
                                this.mod_info.module_stages[ndx].right_border = ( this.mod_info.last_stage != (this.mod_info.steps_completed+1) &&  (ndx+1) == (this.mod_info.steps_completed+1) ) || ( this.mod_info.last_stage ==  (ndx+1) &&  (ndx+1) == (this.mod_info.steps_completed+1) ) ? true : false;
                                
                                this.mod_info.module_stages[ndx].show_completed = (ndx+1) != this.mod_info.last_stage && (ndx+1) <= this.mod_info.steps_completed ? true : false;
                               
                                this.mod_info.module_stages[ndx].show_actions =
                                    this_stage.show_completed ||
                                    ( this.mod_info.status.includes('hold') && this.mod_info.status.includes(this_stage.id) ) ||
                                    ( !this_stage.show_completed && (ndx+1) == 1 ) || 
                                    ( (ndx+1) == this.mod_info.last_stage && this.survey_activated ) ||
                                    ( this_stage.show_completed == false && parseInt(this.mod_info.steps_completed+1) == (ndx+1) && ['schedule_call', 'call_option', 'call_option_final'].includes(this_stage.stage_type) ) ||
                                    ( !this_stage.show_completed && parseInt(this.mod_info.steps_completed+1) == (ndx+1) && this_stage.stage_type == 'revisions' && this.mod_info.dlvs.length ) || //  must have a dlv before it can be revised or not
                                    ( this_stage.show_completed == false && parseInt(this.mod_info.steps_completed+1) == (ndx+1) && this_stage.stage_type == 'opt_out' ) ||
                                    ( this_stage.show_completed == false && parseInt(this.mod_info.steps_completed+1) == (ndx+1) && this_stage.stage_type == 'advance' ) ||
                                    ( this_stage.show_completed == false && parseInt(this.mod_info.steps_completed+1) == (ndx+1) && this_stage.stage_type == 'doc_signing' )    
                                    ? true : false;

                                // CALL ACTIONS
                                this.mod_info.module_stages[ndx].show_calendly = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === false && 
                                    (parseInt(this.mod_info.steps_completed+1) == (ndx+1) && 
                                    ['schedule_call', 'call_option', 'call_option_final'].includes(this_stage.stage_type) ) ? true : false;

                                // REVISIONS ACTIONS
                                this.mod_info.module_stages[ndx].show_revisions_upload = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === false && this_stage.stage_type == 'revisions' && this.mod_info.module_stages[ndx].show_actions ? true : false;

                                // OPT OUT ACTIONS
                                this.mod_info.module_stages[ndx].show_optout_options = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === false && this_stage.stage_type == 'opt_out' ? true : false;
                                // OPT OUT STATEMENT
                                this.mod_info.module_stages[ndx].show_optout_statement = this.mod_info.module_stages[ndx].show_optout_options ?
                                    this.mod_info.module_stages[ndx].extra_details == 'entity_binder' ? `I don't want or need a binder` : '' : ''

                                // DOC SIGNING ACTIONS
                                this.mod_info.module_stages[ndx].show_doc_signing_options = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === false && this_stage.stage_type == 'doc_signing' ? true : false;

                                // ADVANCE PROJECT
                                this.mod_info.module_stages[ndx].show_advance_project = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === false && this_stage.stage_type == 'advance' ? true : false;
                                this.mod_info.module_stages[ndx].show_advance_label = !this.mod_info.status.includes('hold') && 
                                    this_stage.show_completed === true && this_stage.stage_type == 'advance' ? JSON.parse(this.mod_info.module_stages[ndx].extra_details).label : ''
                            
                                if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseVideoList') ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx].stage_desc, 'vInfuseVideoList' )
                                } else if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseVideoSingle') ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx], 'vInfuseVideoSingle' )
                                } else if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseRevisedContract') && this.mod_info.module_stages[ndx].stage_type == 'completion' ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx].stage_desc, 'vInfuseRevisedContract' )
                                } else if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseScheduleCall') ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx].stage_desc, 'vInfuseScheduleCall', this.mod_info.module_stages[ndx].show_calendly )
                                } else if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseScheduleDebriefCall') ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx].stage_desc, 'vInfuseScheduleDebriefCall', this.mod_info.module_stages[ndx].show_calendly )
                                }  else if ( this.mod_info.module_stages[ndx].stage_desc.includes('vInfuseUploadRevisions') ) {
                                    this.mod_info.module_stages[ndx].stage_desc = await this.infuseDynamicContent( this.mod_info.module_stages[ndx].stage_desc, 'vInfuseUploadRevisions', this.mod_info.module_stages[ndx].show_revisions_upload )
                                } 
                            }
                        } else {
                            this.mod_info.test = 'This is a test variable.'
                            this.mod_info.docs = this.mod_info.docs.length ? this.mod_info.docs : []
                            this.mod_info.revs = []
                        }

                        const user_creds = this.mod_info.users != undefined ? this.mod_info.users.find(user => user.user_id == this.authUser.id) : false
                        this.mod_info.can_read = user_creds ? user_creds.read : true
                        this.mod_info.can_write = user_creds ? user_creds.write : true
                        this.mod_info.access_deliverables = user_creds ? user_creds.deliverables : true
                        this.mod_info.expired = user_creds ? parseInt(user_creds.expires) == 0 || parseInt(user_creds.expires) > this.unixTimestamp() ? false : true : false

                        this.survey_team_images = this.mod_info.srg_team.experts;
                        
                        if ( this.mod_info.module_key != undefined ) this.readyToLoad = true
                        if ( this.mod_info.srg_team !== null) this.readyToLoadTeam = true;

                        // console.log(this.mod_info)
                    }
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            infuseDynamicContent: async function ( content, identifier, display=false ) {
                // console.log(this.mod_info.resources)
                // console.log(this.mod_info.resource_visibility)
                try {
                    let infused_content = ''
                    switch ( identifier ) {
                        case 'vInfuseVideoList':
                            const visible_videos = this.mod_info.resources.filter( vid => vid.is_visible_overview)
                            let infuse_list = `<ul>`
                            
                            if ( visible_videos.length ) {
                                this.mod_info.resources.forEach( video => {
                                    if ( this.mod_info.resource_visibility.find(file => file.file_id == video.file_id).is_visible_overview ) {
                                        const display_name = this.mod_info.resource_visibility.find(file => file.file_id == video.file_id).is_visible ? `${video.file_name} <i class="v-icon notranslate ml-2 mdi mdi-checkbox-marked-circle theme--light secondary--text" style="font-size: 19px;"></i>` : `${video.file_name}`
                                        infuse_list += `<li><a data-function="playResourceVideo" data-fileid="${video.file_id}" data-url="${video.url}" data-title="${video.file_name}" data-type="${video.type}">${display_name}</a></li>`
                                    }
                                })
                            } else {
                                infuse_list += `<li><strong>Videos will be visible here when this is the current step.</strong></li>`
                            }
                            infuse_list += `</ul>`
                            infused_content = content.replace(/vInfuseVideoList/g, infuse_list)

                            return infused_content
                        break;

                        case 'vInfuseVideoSingle':
                            const extra_details = JSON.parse(content.extra_details);

                            // const display_name = this.mod_info.resource_visibility.find(file => file.file_id == video.file_id).is_visible ? `${video.file_name} <i class="v-icon notranslate ml-2 mdi mdi-checkbox-marked-circle theme--light secondary--text" style="font-size: 19px;"></i>` : `${video.file_name}`
                            // infuse_list += `<li><a data-function="playResourceVideo" data-fileid="${video.file_id}" data-url="${video.url}" data-title="${video.file_name}" data-type="${video.type}">${display_name}</a></li>`
                            
                            let video;
                            this.mod_info.resources.forEach( v => {
                                if (v.file_id === extra_details.stage_video){
                                    video = v;
                                }
                            });
                            if ( video ){
                                const display_name = this.mod_info.resource_visibility.find(file => file.file_id == video.file_id).is_visible ? `${video.file_name} <i class="v-icon notranslate ml-2 mdi mdi-checkbox-marked-circle theme--light secondary--text" style="font-size: 19px;"></i>` : `${video.file_name}`;
                                const video_content = `<a data-function="playResourceVideo" data-fileid="${video.file_id}" data-url="${video.url}" data-title="${video.file_name}" data-type="${video.type}">${display_name}</a>`;
                                infused_content = content.stage_desc.replace(/vInfuseVideoSingle/g, `<p>${video_content}</p>`);
                            } else {
                                infused_content = content.stage_desc.replace(/vInfuseVideoSingle/g, ``);
                            }
                            

                            return infused_content
                        break;

                        case 'vInfuseRevisedContract':
                            let contract_verbiage = 'contract'
                            if ( this.mod_info.revs.length ) {
                                contract_verbiage = 'revised contract'
                            }
                            infused_content = content.replace(/vInfuseRevisedContract/g, contract_verbiage)

                            return infused_content
                        break;

                        case 'vInfuseScheduleCall':
                            let call_button_verbiage = display ? `<br/><br/>Please use the link below to schedule a consultation call.` : ''
                            infused_content = content.replace(/vInfuseScheduleCall/g, call_button_verbiage)

                            return infused_content
                        break;

                        case 'vInfuseScheduleDebriefCall':
                            let debrief_call_button_verbiage = display ? `<br/><br/>Please use the link below to schedule a debrief call with the valuation team.` : ''
                            infused_content = content.replace(/vInfuseScheduleDebriefCall/g, debrief_call_button_verbiage)

                            return infused_content
                        break;

                        case 'vInfuseUploadRevisions':
                            let upload_revision_button_verbiage = display ? `<br/><br/>Revisions? Please upload document(s) using the button below so we can incorporate any changes or clarifications.<br/><br/>No revisions, please click the checkbox below.`: ''
                            infused_content = content.replace(/vInfuseUploadRevisions/g, upload_revision_button_verbiage)

                            return infused_content
                        break;
                    }
                } catch ( err ) {

                }
            },

            getListingsForBuyer: async function () {
                try {
                    const main_user_id = this.mod_info.secondary_access ? this.mod_info.user_id : this.authUser.id
                    const buyer_listings = await axios.get(`${appUrls.api}/api/current_listings/${main_user_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })

                    // console.log(buyer_listings.data)
                    if ( buyer_listings.data.outcome ) {
                        this.current_listings = buyer_listings.data.current_listings.length ? buyer_listings.data.current_listings.filter( item => item.is_archived == false ) : []
                        this.archived_listings = buyer_listings.data.current_listings.length ? buyer_listings.data.current_listings.filter( item => item.is_archived == true ) : []
                        this.interested_listings = this.current_listings.length ? this.current_listings : []
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            loadInterests: async function (type) {
                this.gatheringInterests = true;
                this.interest_type = type
                
				if (this.interest_type == 'current') this.interested_listings = this.current_listings
				else if (this.interest_type == 'archived') this.interested_listings = this.archived_listings
				this.gatheringInterests = false
            },

            updateListing: async function (action, lid) {
                try {
                    const update_listing = await axios.post(`${appUrls.api}/api/update_listing`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            user_id: this.authUser.id,
                            listing_id: lid,
                            action: action,
                        }
                    })
                
                    if (update_listing.data.outcome) {
                        setTimeout(() => {
                            this.getListingsForBuyer()
                        }, 1000);
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDocs: async function ( project_details ) {
                try {
                    this.refresh_docs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        project_details.docs = pulled_files.data.files.filter( file => file.is_revision == false);
                        project_details.revs = pulled_files.data.files.filter( file => file.is_revision == true);
                        this.refresh_docs = false
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDelivs: async function ( project_details ) {
                try {
                    this.refresh_delivs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        // console.log(pulled_files.data.files)
                        project_details.dlvs = pulled_files.data.files;
                        this.refresh_delivs = false
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            confirmedDeliverable: async function ( document_details ) {
                try {
                    // console.log(document_details)
                    const confirm_doc = await axios.post(`${appUrls.api}/api/confirm_deliverable/${document_details.file_id}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( confirm_doc.data.outcome ) {
                        this.refresh_delivs = true

                        this.mod_info.steps_completed = confirm_doc.data.project.steps_completed
                        this.survey_activated = this.mod_info.steps_completed >= parseInt(this.mod_info.steps_to_complete) ? true : false;
                        if ( this.survey_activated ) this.surveyDialog = true
                    }
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            refreshUsers: async function ( projectId, message_override='' ) {
				try {
					// this.secondaryUserDialog = false
					const project_users = await axios.get(`${appUrls.api}/api/project_users/${projectId}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})
                
					this.mod_info.users = project_users.data.users
                    
					const feedback_msg = message_override != '' ? message_override : project_users.data.message
					this.addUserFeedback({ outcome: project_users.data.outcome, message: feedback_msg });
                
				} catch ( error ) {
                    console.log(error);
                    this.addUserFeedback({ outcome: false, message: error });
                }
            },

            submitSurvey: async function () {
                try {
                    this.$refs.form.validate();
                    if ( this.valid ) {
                        this.surveyDialog = false;

                        this.surveydata.client_name = sessionStorage.name;
                        this.surveydata.module_name = this.mod_info.module_name;

                        const save_survey = await axios.post(`${appUrls.api}/api/save_survey`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: this.surveydata,
                            survey_id: 'd3f6cf9d-4a80-4813-96cd-69da1ce3e39d',
                            project_info: this.mod_info
                        })

                        if ( save_survey.data.outcome ) {
                            this.mod_info.disable_survey = true;
                            this.surveyThanks = true;
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            unixTimestamp () {
                const date = new Date().toGMTString();
                const unixTimestamp = Date.parse(date) / 1000;

                return unixTimestamp
            },

            handleDescClick ( e ) {
                if ( e.target.getAttribute('data-function') ) {
                    const dataFunction = e.target.getAttribute('data-function');
                    const dataFileId   = e.target.getAttribute('data-fileid');
                    const dataUrl      = e.target.getAttribute('data-url');
                    const dataTitle    = e.target.getAttribute('data-title');
                    const dataType     = e.target.getAttribute('data-type');

                    this[dataFunction]( { "fileid": dataFileId, "title": dataTitle, "url": dataUrl, "type": dataType, "access": "step_desc" } )
                }
            },

            playResourceVideo: async function ( data ) {
                this.videoDialog = true
                this.videoUrl   = data.url
                this.videoValid = await this.videoValidation( this.videoUrl )

                if ( this.videoValid ) {
                    this.videoId     = data.fileid
                    this.videoSrc    = data.url.includes('vimeo') ? 'Vimeo' : 'AWS'
                    this.videoTitle  = data.title
                    this.videoType   = data.type

                    if ( data.access == 'step_desc' && this.videoValid ) {
                        // TURN ON VIDEO VISIBILITY IN MODULE RESOURCE AREA WHEN USER OPENS VIDEO FROM WITHIN STEP INFO AREA
                        const project_data = {
                            file_id: [this.videoId],
                            is_visible: this.videoValid,
                            project_id: this.mod_info.project_id,
                            resource_visibility: this.mod_info.resource_visibility,
                            user_id: this.mod_info.user_id
                        }

                        this.activateVideoRes = [ project_data, 'resource' ]
                    }
                }
            },

            videoValidation: async function ( videoUrl ) {
                try {
                    if ( videoUrl.includes('vimeo') ) return true

                    const video_params = new URLSearchParams(videoUrl.split('?')[1]);
                    const signature = video_params.get('Signature') ? video_params.get('Signature') : false
                    const expires = video_params.get('Expires') ? video_params.get('Expires') : false
                    const today = Date.now()

                    return signature && expires && today >= expires
                } catch (error) {
                    // console.log('error', error.response)
                    return false
                }
            },

            updateResourceViz: async function ( project_data, type ) {
                try {
                    const resource_vis = await axios.post(`${appUrls.api}/api/update_resource_visibility/${type}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project_data,
                    })

                    if ( resource_vis.data.outcome ) {
                        this.getCurrentProject()
                    } else {
                        console.log('error updating the resource visibility')
                    }

                } catch ( error ) {
                    console.log(error)
                }
            },

            closeVideo: async function () {
                // Toggle resource visibility of "watched" video                 
                if ( this.activateVideoRes.length ) {
                    await this.updateResourceViz( this.activateVideoRes[0], this.activateVideoRes[1] )
                    this.activateVideoRes = []
                }
                // Reset all video variables
                this.videoDialog    = null
                this.videoValid     = null
                this.videoId        = ''
                this.videoSrc       = ''
                this.videoUrl       = ''
                this.videoType      = ''
                this.videoTitle     = 'Resource Video'
            },

            setupCalendly ( { url, stage_name } ) {
                this.calendly_url       = url;
                this.calendly_mtg_label = stage_name;
                this.calendlyDialog     = true;

                setTimeout(() => {
                    Calendly.initInlineWidget({
                        url,
                        label: stage_name,
                        parentElement: document.getElementById('calendly_wrapper')
                    });
                }, 300);
            },  

            closeCalendly () {
                this.calendlyDialog     = false
                this.calendly_url       = ''
                this.calendly_mtg_label = ''

                // GO FLAG THE DATABASE THAT A CALL HAS BEEN SCHEDULED & SET THE LOCK
            },

            clearSurvey () {
                this.$refs.form.reset()
            },

            closeFileUpload () {
                this.uploadRevisionsDialog = false
                this.uploadIndependentDocsDialog = false
            },

            addResolution: async function(moduleInfo) {
                let response = {}
                try {
                    response = await axios.post(`${appUrls.api}/api/add_submodule`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                      user_id: this.authUser.id,
                      module: moduleInfo
                    }
                    })
                } catch (error) {
                    console.log("Error adding resolution: ", error)
                } finally {
                  this.$router.push({ path: `/module_resolution/${moduleInfo.sub_module_info.module_key}/${response.data.project_id}`});
                }
            },

            getSubProjects: async function(projectId) {
                try {
                    const response = await axios.post(`${appUrls.api}/api/sub_projects`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                      user_id: this.authUser.id,
                      project_id: projectId
                    }
                    })
                    const mod = {...this.mod_info};
                    mod.subProjects = response.data.subProjects
                    this.mod_info = mod;
                } catch(error) {
                    console.log("Error getting subprojects: ", error)
                }
            },
        },
    }
</script>

<style>
    .calendly_dialog {
        overflow: hidden;
    }

    .calendly_dialog #calendly_wrapper {
        height: 720px;
    }
</style>

<style scoped>

    .v-input {
        opacity: 0.9;
        color: blue;
    }
    .min_height {
        min-height: 70vh;
    }
    label.v-label {
        color: blue !important;
    }
    .v-text-field input {
        font-size: .6em;
    }
    .v-tab {
        padding: 2.5rem .5rem !important;
        /* border-bottom:1px solid #EFEFEF; */
        text-align: left !important;
        text-transform: capitalize !important;
    }
    .v-window-item {
        height: 100%
    }
    .step_title {
        /* font-size: .9rem !important; */
        letter-spacing: -0.009em !important;
    }
    .step_subtitle {
        font-size: .8rem !important;
        letter-spacing: -0.009em !important;
    }
    .active_step {
        color: #00818e;
        background-color: #ebf8fa;
    }
    .card-actions {
        position: absolute;
        bottom: 0;
    }
    .step_bottom_border {
        border-bottom: 1px solid #EFEFEF;
    }
    .step_bottom_border_none {
        border-bottom: none;
        /* color: #92c6cc; */
        /* color: #CCEAED; */
    }
    .questionnaire_btm_margin {
        margin-bottom: 50px;
    }
    .disclaimer_list li {
        padding: .8em 0;
    }
    .disclaimer_text_size {
        font-size:1.1em;
    }
    .disclaimer_link_size {
        font-size: .8em;
    }
    .stage_desc >>> i {
        color: #9d9fa2;
    }
    .aws_logo {
        height: .9rem;
    }
    a.buyers_link {
        text-decoration: underline;
    }
    a.buyers_link:hover{
        text-decoration-line: none;
    }
    a.remove_link {
        text-decoration-line: underline;
    }
    a.remove_link:hover {
        text-decoration-line: none;
    }
    .hover_link {
        text-decoration: underline;
    }

    .projecttype {
		color: #5F6062;
        text-decoration-line: none;
	}
    .projecttype:hover {
		text-decoration-line: underline;
	}
  	.projecttype_active {
		position: relative;
		color: #0096A6;
		font-weight: 500;
		text-decoration-line: none;
	}
	.projecttype_active::before {
		content: '';
		position: absolute;
		bottom: -20px;
		left: 0;
		right: 0;
		height: 4px;
		border-radius: 8px;
		background-color: #0096A6;
	}
    >>> .revisions_dialogs {
        align-self: flex-start;
        margin-top: 20%;
        color: rgba(79, 190, 202, 0.84)
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleOverviewInfo.vue